import _defineProperty from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { BaseTransformer } from './BaseTransformer';
import moment from 'moment';

//// 1 - Create / 2 - update / 10 - Not ekeleme 
////  thread task event deal
// auto assignment ıd
// acoıunt_Id
// kb_collection kb_collection_tr collection gelecek

// modüle gibi knowledge base 
export var LastActionTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(LastActionTransformer, _BaseTransformer);
  var _super = _createSuper(LastActionTransformer);
  function LastActionTransformer() {
    _classCallCheck(this, LastActionTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(LastActionTransformer, null, [{
    key: "getName",
    value: function getName(data) {
      var action_name = this.getLabel(data);
      if (data.modelId == "time_entry") {
        var m = moment(data.label2).format("DD MMM YYYY");
        return action_name + " " + data.label + ' ' + m;

        // }else if(data.modelId=="task"){ 
        //   // let subtext = data.label2 ? '-'+data.label2 : '';
        //   let subdetail = data.label2 ? '-'+subtext : '';
        //   return action_name+" "+data.label+' '+subdetail;

        // }else if(data.modelId=="thread"){

        //   let subdetail = data.label2 ? '-'+data.label2 : '';
        //   return data.action_name+" "+data.label+' '+subdetail;

        // }else if(data.modelId=="event"){

        //   let subdetail = data.label2 ? '-'+data.label2 : '';
        //   return data.action_name+" "+data.label+' '+subdetail;
      } else {
        var subdetail = data.label2 ? '-' + data.label2 : '';
        return data.action_name + " " + data.label + '';
      }
    }
  }, {
    key: "getLabel",
    value: function getLabel(data) {
      var title = "";
      switch (data.modelId) {
        case "time_entry":
          title = 'Time Entry';
          break;
        case "task":
          title = 'Task';
          break;
        case "thread":
          title = 'Thread';
          break;
        case "deals":
          title = 'Deals';
          break;
        case "event":
          title = 'Event';
          break;
        case "subtask":
          title = 'Sub Task';
          break;
        case "expense":
          title = 'Expense';
          break;
        case "employee":
          title = 'Employee';
          break;
      }
      return data.actionId == 1 ? 'New ' + title + ' Created' : data.actionId == 2 ? '' + title + ' Updated' : data.actionId == 10 ? 'New Comment' : '';
    }
  }, {
    key: "getIcon",
    value: function getIcon(data) {
      var icon = "";
      switch (data.modelId) {
        case "time_entry":
          icon = 'kv-icon-time-entry';
          break;
        case "task":
          icon = 'kv-icon-task';
          break;
        case "thread":
          icon = 'kv-icon-inbox';
          break;
        case "deals":
          icon = 'kv-icon-deals';
          break;
        case "event":
          icon = 'kv-icon-event';
          break;
        case "subtask":
          icon = 'kv-icon-projects';
          break;
        case "expense":
          icon = 'kv-icon-product-invoice';
          break;
        case "employee":
          icon = 'kv-icon-user';
          break;
      }
      return icon;
    }
  }, {
    key: "fetch",
    value: function fetch(data, locale) {
      var _ref;
      moment.locale(locale);
      return _ref = {
        record_id: data.rel.recordId,
        rel: data.rel,
        history_id: data.history_id,
        record_label: data.record_label,
        label: data.label,
        text: this.getName(data),
        icon: this.getIcon(data),
        os_app_id: data.appId,
        appId: data.appId,
        os_model_id: data.modelId,
        modelId: data.modelId,
        extra_data: data.extra_data,
        workflow: data.workflow,
        super_user: data.super_user,
        model_action_id: data.model_action_id,
        source: data.source,
        created_on: data.created_on,
        created_on_date: moment(data.date).format("DD MMM YYYY"),
        created_on_hour: moment(data.date).format("HH:mm"),
        created_on_day: moment(data.date).format("dddd"),
        data: data.data,
        action_type: data.actionId,
        actionId: data.actionId,
        action_name: data.action_name,
        created_by: data.created_by
      }, _defineProperty(_ref, "record_label", data.record_label), _defineProperty(_ref, "label2", data.label2), _defineProperty(_ref, "type", data.type), _defineProperty(_ref, "app_name", data.app_name), _defineProperty(_ref, "font_icon", data.font ? data.font.replace('-2', '').replace('-o', '') : ''), _defineProperty(_ref, "model_name", data.model_name), _ref;
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return LastActionTransformer;
}(BaseTransformer);